module.exports = __webpack_public_path__ + "img/subsurface elements.83efacb6.jpg";